<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>수정/삭제 승인(내담자) 목록</p>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_tab">
                        <div
                            :class="{ selected: state.dept === null }"
                            @click="
                                state.dept = null;
                                fnGetList(1);
                            "
                        >
                            <span>전체</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 1 }"
                            @click="
                                state.dept = 1;
                                fnGetList(1);
                            "
                        >
                            <span>상담팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 3 }"
                            @click="
                                state.dept = 3;
                                fnGetList(1);
                            "
                        >
                            <span>현장팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 4 }"
                            @click="
                                state.dept = 4;
                                fnGetList(1);
                            "
                        >
                            <span>기타</span>
                        </div>
                    </div>
                </div>
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>
                            <div style="display: flex; justify-content: center; align-items: center">
                                <div class="total_length">
                                    {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                                </div>

                                <div class="area_button" style="margin-left: 5px">
                                    <button type="button" @click="confirmAccessAll">
                                        <span>일괄 승인</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                                @allClick="selectAll"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <AccessDetail
        v-if="state.isShowDetail"
        :idx="state.idx"
        @close="state.isShowDetail = false"
        @callback="
            state.isShowDetail = false;
            fnGetList(pageState.currentPage);
        "
    ></AccessDetail>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        DataGrid,
        reactive,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        AccessDetail,
        onActivated,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, AccessDetail },
        setup() {
            const state = reactive({
                order: 0 as number,
                dept: null as 1 | 3 | 4 | null,
                isShowDetail: false as boolean,
                idx: 0 as number,
                idxList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    {
                        key: "checkbox",
                        label: "",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            return `<div class="checkbox_wrap">
                                    <label for="checkbox${row.idx}">
                                        <input type="checkbox" id="checkbox${row.idx}" ${
                                row.state === 0 && row.clientVO && row.checked === true ? "checked" : ""
                            } ${row.state === 0 && row.clientVO ? "" : "disabled"} />
                                        <em></em>

                                    </label>
                                </div>`;
                        },
                    },
                    { key: "", label: "No.", class: "text-center" },
                    {
                        key: "clientVO.number",
                        label: "연번",
                        class: "text-left",
                        clickable: true,
                        render: (row: any) => {
                            if (row.clientVO) return row.clientVO.number;
                            else return "이미 삭제된 데이터입니다.";
                        },
                    },
                    {
                        key: "clientVO.type",
                        label: "성매매유형",
                        class: "text-center",
                        render: (row: any) => {
                            if (row.clientVO) return row.clientVO.type;
                            else return "이미 삭제된 데이터입니다.";
                        },
                    },
                    {
                        key: "clientVO.state",
                        label: "상태",
                        class: "text-center",
                        render: (row: any) => {
                            let strResult = "";
                            if (row.clientVO) {
                                switch (row.clientVO.state) {
                                    case 0:
                                        strResult = "데이터 없음";
                                        break;
                                    case 1:
                                        strResult = "진행";
                                        break;
                                    case 2:
                                        strResult = "종결";
                                        break;
                                    case 3:
                                        strResult = "보류";
                                        break;
                                    case 4:
                                        strResult = "비해당";
                                        break;
                                    default:
                                        strResult = "데이터 없음";
                                        break;
                                }
                                if (
                                    row.clientVO.state === 1 &&
                                    row.clientVO.stateSub &&
                                    row.clientVO.stateSub !== "" &&
                                    row.clientVO.stateSub !== "-"
                                ) {
                                    strResult += ` (${row.clientVO.stateSub})`;
                                }
                            }
                            return strResult;
                        },
                    },
                    { key: "strGubun", label: "구분", class: "text-center" },
                    { key: "reason", label: "사유", class: "text-left" },
                    { key: "strDept", label: "부서", class: "text-center" },
                    { key: "writer.name", label: "담당자", class: "text-center" },
                    {
                        key: "createDate",
                        label: "요청일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormat(row.createDate, ".", true);
                        },
                    },
                    {
                        key: "confirmUser.name",
                        label: "승인자",
                        class: "text-center",
                    },
                    {
                        key: "strState",
                        label: "승인상태",
                        class: "text-center",
                        clickable: true,
                        render: (row: any) => {
                            if (row.state === 0 && row.clientVO) {
                                return `<button type = "button" class = "blueBtn">${row.strState}</button>`;
                            } else {
                                return row.strState;
                            }
                        },
                    },
                ],
            });

            onActivated(() => {
                initState();
                fnGetList(pageState.currentPage);
            });

            const initState = () => {
                state.isShowModal = false;
                state.isShowDetail = false;
                state.modalTab = -1;
                state.modalTitle = "";
                state.modalContent = "";
                pageState.list = [];
                pageState.isLoading = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    saveAccessAll();
                }
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.accessRequest.ReqAccessRequestForList = {
                    type: 1,
                    dept: state.dept,
                    page: page,
                    size: pageState.perPage,
                    order: state.order,
                    startDate: null,
                    endDate: null,
                    searchType: "",
                    searchText: "",
                };
                let res: types.ResPaging = await apiService.accessRequest.list(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const selectAll = (checked: boolean) => {
                pageState.list.forEach((item: any) => {
                    if (item.state === 0 && item.clientVO) item.checked = checked;
                });

                if (checked) {
                    state.idxList = [];
                    pageState.list.forEach((item: any) => {
                        if (item.checked) state.idxList.push(item.idx);
                    });
                } else {
                    state.idxList = [];
                }
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "clientVO.number") {
                    if (row.clientVO) {
                        router.push({ name: "clientDetail", params: { id: row.clientVO.idx } });
                    }
                } else if (col.key === "strState") {
                    if (row.counselVO || row.clientVO) {
                        state.idx = row.idx;
                        state.isShowDetail = true;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "이미 삭제된 데이터입니다.";
                        state.isShowModal = true;
                    }
                } else if (col.key === "checkbox") {
                    if (row.checked) {
                        row.checked = false;
                        state.idxList.splice(state.idxList.indexOf(row.idx), 1);
                    } else {
                        row.checked = true;
                        if (state.idxList.indexOf(row.idx) === -1) state.idxList.push(row.idx);
                    }
                }
            };

            const confirmAccessAll = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 승인하시겠습니까?";
                state.isShowModal = true;
            };

            const saveAccessAll = async () => {
                if (state.idxList && state.idxList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                const res = await apiService.accessRequest.modifyForMulti(state.idxList.join(","));

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "처리 되었습니다.";
                    state.isShowModal = true;

                    fnGetList(pageState.currentPage);
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            return {
                state,
                pageState,
                selectAll,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                closeModal,
                callBackModal,
                confirmAccessAll,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
